<template>
  <div class="container topPage noticeIndex">
    <!-- <van-nav-bar title="消息" left-text /> -->
    <div class="padding15">
      <h3 class="mtp0important">通知</h3>
      <van-skeleton row="6" :loading="skeletonLoading">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="亲，已经到底啦"
          @load="onLoad"
          :immediate-check="false"
          :error.sync="error"
          error-text="请求失败，点击重新加载"
          :offset="30"
        >
          <div class="noticeList">
            <div
              class="noticeItem"
              v-for="(item, index) in noticeList"
              :key="index"
            >
              <div class="noticeImg">
                <van-icon name="star-o" />
              </div>
              <div class="noticeCon">
                <div class="subTitle">系统消息</div>
                <div class="con">{{item.message}}</div>
              </div>
              <div class="time">{{item.createTime}}</div>
            </div>
            <van-empty
              class="custom-image"
              :image="dataNullImg"
              description
              v-if="isEmpty"
            />
          </div>
        </van-list>
      </van-skeleton>
    </div>

    <tab-bar></tab-bar>
    <div class="blankHeight"></div>
  </div>
</template>

<script>
import { ownerList } from "@/api/data";
import tabBar from "@/view/component/tabBar";
export default {
  components: { tabBar },
  data() {
    return {
      skeletonLoading: true,
      loading: false,
      dataNullImg: require("@/assets/images/dataNull.png"),
      noticeList: [],
      isEmpty: false,
      finished: false,
      error: false,
      pageInfo: {
        page: 1,
        limit: 10,
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      let _this = this;
      ownerList(_this.pageInfo).then((res) => {
        _this.skeletonLoading = false;
        if (res.data.totalCount == 0) {
          _this.isEmpty = true;
        } else {
          _this.isEmpty = false;
        }
        if (!res.data.list) {
          _this.finished = true;
          return;
        }
        setTimeout(() => {
          _this.noticeList.push(...res.data.list);
          _this.loading = false;
          if (
            res.data.currPage === res.data.totalPage &&
            res.data.totalCount > 0
          ) {
            _this.finished = true;
            _this.finishText = "亲，已经到底啦";
            return;
          }
        }, 300);
      });
    },
    onLoad() {
      this.pageInfo.page++;
      this.getList();
    },
  },
};
</script>

<style lang='less'>
.noticeIndex {
  .noticeList {
    .noticeItem {
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
      margin-bottom: 20px;
      display: flex;
      position: relative;
      border-radius: 10px;
      padding: 10px 8px;
      .noticeImg {
        padding: 8px;
        width: 21px;
        height: 21px;
        background: #d44e43;
        border-radius: 50%;
        margin-right: 15px;

        .van-icon {
          font-size: 20px !important;
          color: #fff;
          height: 22px;
          width: 22px;
        }
      }
      .noticeCon {
        flex: 1;
        .subTitle {
          color: #000;
          font-size: 14px;
        }
        .con {
          color: #666;
          font-size: 12px;
          margin-top: 3px;
        }
      }
      .time {
        position: absolute;
        right: 10px;
        top: 10px;
        color: #666;
        font-size: 12px;
      }
    }
  }
}
</style>